<template>
  <div class="h-full w-full flex flex-column">
    <slot name="header" />
    <transition name="fade">
      <div class="grid" :class="{ 'grid-expanded': isExpandedLayout, 'grid-stacked-side': isStackedSideLayout }">
        <slot name="side" />
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  computed: {
    isExpandedLayout() {
      const expandedPaths = ["/nolanovel", "/agent", "/commerce-debut-guide", "/agent/description"];
      return expandedPaths.includes(this.$route.path);
    },
    isStackedSideLayout() {
      const { name } = this.$route;
      const stackedSidePaths = [
        "eventContest",
        "eventContestDetail",
        "eventContestEntry",
        "eventAgentEntry",
        "entries",
        "entryProfile",
      ];
      return stackedSidePaths.includes(name);
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.h-full {
  height: 100%;
}

.w-full {
  width: 100%;
}

.grid {
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-rows: calc(100vh - #{$header-height});
}

.grid-expanded {
  grid-template-columns: 360px 1fr;
  /* 特定パス用のカラム幅 */
}

.grid-stacked-side {
  @include mq("sp") {
    grid-template-columns: 1fr;
    grid-template-rows: auto minmax(0, 1fr);
    height: calc(100vh - #{$header-height});
    min-height: 0;
  }
}
</style>
